module.exports = __webpack_public_path__ + "img/DSC07859-Edit-.6f112243.png";